<template>
  <Content>
    <form @submit.prevent="submitForm">
      <div class="container-fluid py-4">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h3 class="page-title mb-1">{{ currentLang.title }}</h3>
            <p class="page-subtitle mb-0">
              {{ currentLang.detail }}
            </p>
          </div>

          <button
            @click="$router.push('/admin')"
            class="btn btn-light back-btn"
          >
            {{ currentLang.back }}
          </button>
        </div>

        <ErrorAlert v-if="errorMessage" :message="errorMessage" />

        <div class="row g-4">
          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.phone }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderPhone"
              v-model="form.phone"
              required
            />
          </div>

        
          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.title }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderTitle"
              v-model="form.title"
            />
          </div>

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.address }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderAddress"
              v-model="form.address"
            />
          </div>


            <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.details }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderDetails"
              v-model="form.details"
            />
          </div>

        

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.postalCode }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderPostalCode"
              v-model="form.postal_code"
            />
          </div>

       
          <!-- locations -->

          <!-- کشور -->
          <div class="col-12 col-md-4">
            <label class="custom-label">{{ currentLang.country }}</label>
            <input
              class="form-control custom-input"
              list="list-countries"
              :value="countryName"
              @input="handleInput('country', $event.target.value)"
              @change="syncLocation('country')"
            />
            <datalist id="list-countries">
              <option v-for="c in countries" :key="c.id" :value="c.name" />
            </datalist>
          </div>

          <!-- استان -->
          <div class="col-12 col-md-4">
            <label class="custom-label">{{ currentLang.province }}</label>
            <input
              class="form-control custom-input"
              list="list-provinces"
              :value="provinceName"
              @input="handleInput('province', $event.target.value)"
              @change="syncLocation('province')"
              :disabled="!form.country_id"
            />
            <datalist id="list-provinces">
              <option v-for="p in provinces" :key="p.id" :value="p.name" />
            </datalist>
          </div>

          <!-- شهر -->
          <div class="col-12 col-md-4">
            <label class="custom-label">{{ currentLang.city }}</label>
            <input
              class="form-control custom-input"
              list="list-cities"
              :value="cityName"
              @input="handleInput('city', $event.target.value)"
              @change="syncLocation('city')"
              :disabled="!form.province_id"
            />
            <datalist id="list-cities">
              <option v-for="c in cities" :key="c.id" :value="c.name" />
            </datalist>
          </div>

          <div class="d-flex justify-content-end mt-5">
            <button class="btn save-btn" :disabled="loading">
              {{ loading ? currentLang.saving : currentLang.save }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </Content>
</template>
<script setup>
import { alertStore } from "@/stores/alertStore";
import Content from "@/components/AdminContent.vue";
import { lang } from "@/plugins/lang";
import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import api from "@/plugins/axios";
import ErrorAlert from "@/components/alerts/ErrorAlert.vue";
const errorMessage = ref("");
const route = useRoute();
const router = useRouter();
const isEdit = computed(() => !!route.params.id);
const userId = computed(() => route.params.user_id || "");
import { showLoading, hideLoading } from "@/stores/loading";

import enText from "@/locales/en/addressPage";
import faText from "@/locales/fa/addressPage";

const translations = {
  en: enText,
  fa: faText,
};
const currentLang = computed(() => translations[lang.value]);

const loading = ref(false);

// اضافه کردن در بالای اسکریپت
const countries = ref([]);
const provinces = ref([]);
const cities = ref([]);
const countryName = ref("");
const provinceName = ref("");
const cityName = ref("");
let timers = { country: null, province: null, city: null };

const form = ref({
  title: "",
  phone: "",
  address: "",
  details: "",
  postal_code: "",
  country_id: "",
  province_id: "",
  city_id: "",
});

const submitForm = async () => {
  try {
    loading.value = true;
      showLoading();


      const payload = {
      ...form.value,
      user_id: userId.value,
    };

    const response = isEdit.value
      ? await api.patch(`admin/address/${route.params.id}`, form.value)
      : await api.post("admin/address", payload);

    if (response.status === 201 || response.status === 200) {
      alertStore.trigger(
        "success",
        currentLang.value.success,
        response?.data?.message || ""
      );
      router.push("/address");
    } else {
      errorMessage.value = response?.data?.message || "networkError";
    }
  } catch (error) {
    errorMessage.value = error.response?.data?.message || "error";
  } finally {
    loading.value = false;
    hideLoading();

  }
};

const getAddress = async () => {
  try {
    loading.value = true;
    showLoading();


    const response = await api.get(`admin/address/${route.params.id}`);

    const address = response.data.data;

    form.value.title = address.title;
    form.value.phone = address.phone;
    form.value.address = address.address;
    form.value.details = address.details;
    form.value.postal_code = address.postal_code;

    form.value.country_id = address.country?.id || "";
    form.value.province_id = address.province?.id || "";
    form.value.city_id = address.city?.id || "";

    countryName.value = address.country?.name || "";
    provinceName.value = address.province?.name || "";
    cityName.value = address.city?.name || "";


     if (form.value.country_id) {
       onSearch("province", ""); 
    }
    if (form.value.province_id) {
       onSearch("city", "");
    }
   
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
        hideLoading();

  }
};

// توابع جستجو و هندلینگ
const onSearch = async (type, query) => {
  let url = "";
  if (type === "country") url = `general/location/countries?name=${query}`;
  if (type === "province")
    url = `general/location/provinces?country_id=${form.value.country_id}&name=${query}`;
  if (type === "city")
    url = `general/location/cities?province_id=${form.value.province_id}&name=${query}`;

  const res = await api.get(url);
  if (type === "country") countries.value = res.data.data;
  if (type === "province") provinces.value = res.data.data;
  if (type === "city") cities.value = res.data.data;
};

const handleInput = (type, val) => {
  if (type === "country") {
    countryName.value = val;
    form.value.country_id = "";
    resetLocations("country");
  }
  if (type === "province") {
    provinceName.value = val;
    form.value.province_id = "";
    resetLocations("province");
  }
  if (type === "city") {
    cityName.value = val;
    form.value.city_id = "";
  }

  clearTimeout(timers[type]);
  timers[type] = setTimeout(() => onSearch(type, val), 400);
};




const syncLocation = async (type) => {
  let list = [];
  if (type === "country") list = countries.value;
  if (type === "province") list = provinces.value;
  if (type === "city") list = cities.value;

  const searchTerm = type === "country" ? countryName.value : type === "province" ? provinceName.value : cityName.value;
  const item = list.find((i) => i.name === searchTerm);

  if (item) {
    if (type === "country") {
      form.value.country_id = item.id;
      await onSearch("province", ""); // لود کردن لیست استان‌ها بلافاصله بعد از انتخاب کشور
    }
    if (type === "province") {
      form.value.province_id = item.id;
      await onSearch("city", ""); // لود کردن لیست شهرها بلافاصله بعد از انتخاب استان
    }
    if (type === "city") {
      form.value.city_id = item.id;
    }
  }
};








const resetLocations = (level) => {
  if (level === "country") {
    form.value.province_id = "";
    form.value.city_id = "";
    provinceName.value = "";
    cityName.value = "";
    provinces.value = [];
    cities.value = [];
  } else if (level === "province") {
    form.value.city_id = "";
    cityName.value = "";
    cities.value = [];
  }
};


onMounted(() => {
  onSearch("country", "");
  if (route.params.id) {
    getAddress();
  }
});
</script>


<style scoped>
.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
}

.page-subtitle {
  color: #64748b;
  font-size: 14px;
}

.custom-label {
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}

.custom-input {
  height: 48px;
  border-radius: 10px;
  border: none;
  font-size: 14px;
  padding: 0 14px;
  transition: 0.2s ease;
  background: #fff;

  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08);
}

.custom-input:focus {
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08),
    0 0 0 3px rgba(59, 130, 246, 0.15);

  outline: none;
}

.save-btn {
  min-width: 160px;
  height: 46px;
  border: none;
  border-radius: 10px;
  background: #16a34a;
  color: white;
  font-weight: 600;
  padding: 0 24px;
  transition: 0.2s ease;

  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25);
}

.save-btn:hover {
  background: #15803d;
  color: white;
}

.back-btn {
  border: none;
  border-radius: 10px;
  padding: 10px 18px;
  background: #ffffff;
  color: #334155;
  font-weight: 600;
  transition: 0.2s ease;

  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08);
}

.back-btn:hover {
  background: #f8fafc;
  color: #0f172a;

  transform: translateY(-1px);

  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
}

.custom-input:disabled {
  background: #f1f5f9;
  cursor: not-allowed;
  opacity: 0.8;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 22px;
  }

  .save-btn {
    width: 100%;
  }
}
.required {
  color: red;
  margin-right: 4px;
}
</style>